import { AccessibilityHelpers } from '../Util/Accessibility.js';
import {createFocusTrap} from 'focus-trap';
export class Header {
  constructor() {
    this.headerEl = document.querySelector('.YxtHeader');
    this.menuEl = document.querySelector('.Header-menu');
    this.menuOpenBtn = document.querySelector('.Header-openBtn');
    this.menuCloseBtn = document.querySelector('.Header-closeBtn');
    this.menuItems = document.querySelectorAll('.Header-links--mobile a');
    this.mobileBPMatcher = window.matchMedia('(max-width: 767px)');

    this.dropDowns = document.querySelectorAll('.Header-dropDown');

    this.accessibilityHelpersInstance = new AccessibilityHelpers();

    this.initFocusTrap();
    this.initListeners();
    this.initMobileHeader();
  }

  initFocusTrap() {
    this.focusTrap = createFocusTrap(this.menuEl, {
      initialFocus: this.menuCloseBtn,
      onActivate: () => {
        this.handleHeaderTabIndexes(0);
      },
      onDeactivate: () => {
        this.handleHeaderTabIndexes(-1);
      },
    });
  }

  handleHeaderTabIndexes(tabIndex) {
    this.accessibilityHelpersInstance.setTabIndex(this.menuItems, tabIndex);
  }

  initMobileHeader() {
    this.handleMobileHeader();
    this.mobileBPMatcher.addListener(this.handleMobileHeader.bind(this));
  }

  handleMobileHeader() {
    if (this.mobileBPMatcher.matches) {
      this.enableMobileHeader();
    } else {
      this.resetMobileHeader();
    }
  }

  resetMobileHeader() {
    this.closeMobileMenu();
    this.handleHeaderTabIndexes(0);
    this.accessibilityHelpersInstance.setAriaProp(this.menuEl, 'hidden', false);
  }

  enableMobileHeader() {
    this.handleHeaderTabIndexes(-1);
    this.accessibilityHelpersInstance.setAriaProp(this.menuEl, 'hidden', true);
  }

  initListeners() {

    this.menuOpenBtn.addEventListener('click', () => {
      this.openMobileMenu();
    });

    this.menuCloseBtn.addEventListener('click', () => {
      this.closeMobileMenu();
    });

    document.addEventListener('keydown', (e) => {
      // Close header on Escape
      if (e.keyCode === 27 && this.menuEl.classList.contains('is-open-mobile')) {
        this.closeMobileMenu();
      }
    });


    document.addEventListener('click', (e) => {
      // Close header on Escape
      for (const dropDown of this.dropDowns) {
        const button = dropDown.querySelector('.js-dropDown-Btn');
        if (e.target.matches(`#${button.id}`)) {
          dropDown.classList.toggle("is-active");
        } else if (e.target.matches(".Header-mobileBack")) {
          //if on mobile and back button appears return to normal menu
          dropDown.classList.toggle("is-active");
        } else if (!(e.target.matches(".Header-dropDownContent") ||  e.target.matches(".Header-dropDownLink"))) {
          if (dropDown.classList.contains('is-active')){
            dropDown.classList.remove('is-active');
          }
        }
      }
    });
  }

  openMobileMenu() {
    this.menuEl.classList.add('is-open-mobile');
    this.focusTrap.activate();

    this.accessibilityHelpersInstance.setAriaProp(this.menuEl, 'hidden', false);
    this.accessibilityHelpersInstance.setAriaProp(this.menuCloseBtn, 'expanded', true);
    this.accessibilityHelpersInstance.setAriaProp(this.menuOpenBtn, 'expanded', true);
  }

  closeMobileMenu() {
    this.menuEl.classList.remove('is-open-mobile');
    this.focusTrap.deactivate();

    this.accessibilityHelpersInstance.setAriaProp(this.menuEl, 'hidden', true);
    this.accessibilityHelpersInstance.setAriaProp(this.menuCloseBtn, 'expanded', false);
    this.accessibilityHelpersInstance.setAriaProp(this.menuOpenBtn, 'expanded', false);
  }
}